// Do not include any other exprot in this file
// Had issues with exports possibly due to cyclic dependencies
import App from './components/App'

export default App
